/*
 * @Author: your name
 * @Date: 2021-01-20 10:59:04
 * @LastEditTime: 2021-06-07 16:50:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/modules/app.js
 */

const IS_SAME_PAGE_NAME = null

const IS_FROM_MENU_TO_START_TAB = {
  TARGET_PAGE_LIST: ['start-tab'],
  ALLOW_FROM_PAGE_LIST: [
    'contact-details',
    'order-history',
    'card-detail', // for back from credit-card page
  ],
  VUEX_MUTATION_NAME: 'saveIsFromMenuToStartTab',
}

const IS_FROM_START_TAB_TO_CARD_DETAILS = {
  TARGET_PAGE_LIST: ['card-detail'],
  ALLOW_FROM_PAGE_LIST: [
    'start-tab',
  ],
  VUEX_MUTATION_NAME: 'saveIsFromStartTabToCardDetails',
}

const IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL = {
  TARGET_PAGE_LIST: ['pay', 'my-order'],
  ALLOW_FROM_PAGE_LIST: [
    'order-history'
  ],
  VUEX_MUTATION_NAME: 'saveIsFromOrderHistoryToOrderDetail',
}

const IS_FROM_MENU_TO_CONTACT_DETAIL = {
  TARGET_PAGE_LIST: ['contact-details'],
  ALLOW_FROM_PAGE_LIST: [
    'venue-home-pick',
    'venue-home-table',
    'my-order',
    'order-history',
    'start-tab', // for back from start-tab page
    'tab-menu', // create tab from tab-menu page
  ],
  VUEX_MUTATION_NAME: 'saveIsFromMenuToContactDetail',
}

export {
  IS_SAME_PAGE_NAME,
  IS_FROM_START_TAB_TO_CARD_DETAILS,
  IS_FROM_MENU_TO_START_TAB,
  IS_FROM_ORDER_HISTORY_TO_ORDER_DETAIL,
  IS_FROM_MENU_TO_CONTACT_DETAIL,
}